<template>
    <div class="main-body">
        <h2>{{ $strings('spsite/cp/title') }}</h2>
        <div class="action-bar">
            <div class="add-wrapper">
                <el-button size="small" type="primary" @click="onCreate">{{ $strings('word/create') }}</el-button>
            </div>
            <div class="filter-wrapper">
                <el-form :inline="true" :model="formFilter" class="demo-form-inline" ref="filter">
                    <el-form-item label="">
                        <el-input v-model="formFilter.cp_name" placeholder="CpName" size="small"
                                  class="max-width-120" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onFilter" size="small">{{
                                $strings('word/query')
                            }}
                        </el-button>
                        <el-button @click="onReset" size="small">{{ $strings('word/reset') }}</el-button>
                        <el-button @click="onRefresh" size="small" :loading="refreshing">{{
                                $strings('word/refresh')
                            }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="data-area">
            <el-table
                v-loading="loading"
                border
                :data="tableData"
                style="width: 100%">
                <el-table-column prop="cp_id" label="ID" width="100">
                    <template slot-scope="scope"><span class="code-text">{{ scope.row.cp_id }}</span></template>
                </el-table-column>
                <el-table-column prop="cp_name" label="Name" width="108"></el-table-column>
                <el-table-column prop="cp_status" label="Status" width="120">
                    <template slot-scope="scope">{{ $strings('spsite/cp/cp_status/' + scope.row.cp_status) }}</template>
                </el-table-column>
                <el-table-column prop="ips" label="IPs" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cp_token" label="Token" show-overflow-tooltip width="312">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="$strings('spsite/cp/tips_token')"
                                    placement="top-start">
                            <span class="code-text">{{ scope.row.cp_token }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="ct_time" label="CreateTime" width="100">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="Remark" width="180"></el-table-column>
                <el-table-column label="Edit" width="100">
                    <template slot-scope="scope">
                        <el-button size="small" @click="onEdit(scope.row)">Edit</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination margin-top-1" v-if="pagination.total > pagination.size" style="text-align: right">
                <el-pagination background layout="prev, pager, next" :total="pagination.total"
                               :page-size.sync="pagination.size"
                               :current-page.sync="pagination.page" @current-change="refreshData"></el-pagination>
            </div>
        </div>
        <el-dialog
            :title="isEdit ? $strings('word/edit') : $strings('word/create')"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            @closed="onClose"
            width="30%">
            <div>
                <el-form ref="form" :model="editForm" label-width="80px" :rules="rules">
                    <el-form-item :label="$strings('spsite/cp/prop_cp')" prop="cp_name" v-if="!isEdit">
                        <el-input v-model="editForm.cp_name" clearable maxlength="8" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('word/ips')" prop="ips">
                        <el-input v-model="editForm.ips" clearable maxlength="32" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('spsite/cp/prop_remark')" prop="remark">
                        <el-input v-model="editForm.remark" clearable maxlength="24" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $strings('word/cancel') }}</el-button>
                <el-button type="primary" @click="onSaveEdit()" :loading="saving">{{ $strings('word/confirm') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {SpSiteCpCreate, SpSiteCpRead, SpSiteCpRefreshCache, SpSiteCpUpdate} from "@/api/spsite/api";
import {API_STATUS_CODE, STORAGE_KEY_LOGIN_TZ} from "@/config/config";
import {UnixToDateYMD} from "@/utils/time";
import {GetItem} from "@/utils/storage";

export default {
    name: "spsite-cp",
    data() {
        return {
            loading: true,
            refreshing: false,
            isEdit: false,
            saving: false,
            editForm: {},
            formFilter: {},
            tableData: [],
            dialogVisible: false,
            pagination: {
                total: 0,
                page: 1,
                size: 12,
            },
            rules: {
                remark: [
                    {required: true, message: this.$strings('spsite/cp/error/remark_empty'), trigger: 'blur'}
                ],
                ips: [
                    {required: true, message: this.$strings('spsite/cp/error/remark_empty'), trigger: 'blur'}
                ],
                cp_name: [
                    {required: true, message: this.$strings('spsite/cp/error/cp_name_empty'), trigger: 'blur'},
                    {min: 3, max: 8, message: this.$strings('spsite/cp/error/cp_name_empty'), trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
        this.refreshData();
    },
    computed: {},
    methods: {
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateYMD(ts, tz);
        },
        onFilter() {
            this.refreshData();
        },
        onReset() {
            this.formFilter = {};
            this.refreshData();
        },
        onClose() {
            this.saving = false
            this.$refs["form"].clearValidate();
        },
        onEdit(row) {
            this.isEdit = true;
            this.editForm = row;
            this.dialogVisible = true;
        },
        onCreate() {
            this.isEdit = false;
            this.editForm = {};
            this.dialogVisible = true;
        },
        onSaveEdit() {
            this.saving = true;
            let action = this.isEdit ? SpSiteCpUpdate : SpSiteCpCreate;
            action(this.editForm).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.dialogVisible = false;
                    this.isEdit = false;
                    this.refreshData();
                    this.onRefresh();
                }
            });
        },
        refreshData() {
            this.loading = true;
            this.formFilter.size = this.pagination.size;
            this.formFilter.page = this.pagination.page;
            SpSiteCpRead(this.formFilter).then((resp) => {
                this.tableData = resp.data.data.count > 0 ? resp.data.data.rows : [];
                this.pagination.total = resp.data.data.count;
            }).finally(() => {
                this.loading = false;
            })
        },
        onRefresh() {
            this.refreshing = true;
            SpSiteCpRefreshCache({page: 1, size: 100}).then(() => {
                this.refreshing = false;
            }).finally(() => {
                this.refreshing = false;
            });
        }
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: row;

    .filter-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
    }

    .add-wrapper {
        padding-top: 4px;
    }
}

.table-pagination {
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
}
</style>